var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"user-tag"},[_c('UserAvatar',{attrs:{"user-avatar":_vm.avatar}}),_c('span',[_vm._v(_vm._s(_vm.userName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }